import { ClientLambdaApi } from '@/api-client'

/**
 * Get list of all users with root access
 * @returns {Promise} Root users list
 */
export const getRootUsers = async () => {
  try {
    const response = await ClientLambdaApi.get('/admin/root-users')
    return response.data
  } catch (error) {
    console.error('Error fetching root users:', error)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/rootUsersService.js